import { createContext } from 'react';
import { useRemoteConfig } from '../hooks/useRemoteConfig';

// RemoteConfigContext is kept for backwards compatibility but no longer consumed
// directly — components use useRemoteConfig() or getConfigValue() from the service.
export const RemoteConfigContext = createContext();

export const RemoteConfigProvider = (props) => {
	const { getValue } = useRemoteConfig();

	return (
		<RemoteConfigContext.Provider value={{ getValue }}>
			{props.children}
		</RemoteConfigContext.Provider>
	);
};
